import { createFileRoute } from "@tanstack/react-router";
import { getForumPost } from "@/features/community/records";
import { ForumPostPage, communityHead } from "@/features/community";
import {
  CommunityPageLoading,
  CommunityPageError,
} from "@/features/community/navigation";

export const Route = createFileRoute("/_site/$coworld/forum/$postId")({
  loader: ({ location, abortController }) =>
    getForumPost({
      data: { href: location.href },
      signal: abortController.signal,
    }),
  head: ({ loaderData }) => communityHead(loaderData?.metadata),
  pendingComponent: () => <CommunityPageLoading title="Forum" />,
  errorComponent: ({ error, reset }) => (
    <CommunityPageError error={error} retry={reset} />
  ),
  component: () => <ForumPostPage data={Route.useLoaderData()} />,
});
